var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJmd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3069 2.74796C17.2834 1.1926 14.7505 0.267334 12.0011 0.267334C9.2517 0.267334 6.71877 1.19265 4.69531 2.74796L12.0011 10.0537L19.3069 2.74796Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48058 4.96265C0.925312 6.9861 0 9.51899 0 12.2684C0 15.0178 0.925312 17.5507 2.48062 19.5742L9.78642 12.2684L2.48058 4.96265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69531 21.784C6.71881 23.3394 9.2517 24.2646 12.0011 24.2646C14.7505 24.2646 17.2834 23.3393 19.3069 21.784L12.0011 14.4783L4.69531 21.784Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5206 19.5741C23.0759 17.5507 24.0012 15.0178 24.0012 12.2684C24.0012 9.51899 23.0759 6.9861 21.5206 4.96265L14.2148 12.2684L21.5206 19.5741Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJmd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/JMD.914995b9fff57cb416c00b2d8bae1037.svg";